import React from 'react';
import { FormattedNumber, FormattedMessage } from 'react-intl';

import { fontSize, colors } from 'styles/cp';

export interface BatchInvoiceSummaryProps {
  invoiceNumber?: string | React.ComponentElement<any, any>;
  invoiceAmount: number;
  currency?: string;
  outstandingBalance?: number | null;
}

const BatchInvoiceSummary: React.FC<BatchInvoiceSummaryProps> = ({
  invoiceNumber,
  invoiceAmount,
  currency,
  outstandingBalance = null,
}) => {
  return (
    <>
      <li aria-label="data row item">
        <div className="space-between flex-row" style={{ gap: 15 }}>
          <span className="label left">
            <span className="invoice-label">
              <FormattedMessage id="INVOICE_SUMMARY_INVOICE" defaultMessage="Invoice" />
            </span>
            <span className="invoice-number">{invoiceNumber}</span>
          </span>
          <span className="label label-data right" data-cy="data-row-value-target">
            <div className="amount-container">
              <FormattedNumber value={invoiceAmount} style="currency" currency={currency} />
              {outstandingBalance !== null && (
                <span className="outstanding-balance-text">
                  <FormattedNumber
                    value={outstandingBalance}
                    style="currency"
                    currency={currency}
                  />{' '}
                  <FormattedMessage id="OUTSTANDING_BALANCE" defaultMessage="outstanding balance" />
                </span>
              )}
            </div>
          </span>
        </div>
      </li>
      {/*language=SCSS*/}
      <style jsx>{`
        .space-between {
          display: flex;
          justify-content: space-between;
        }
        .flex-row {
          flex-direction: row;
          margin: 6px 0px;

          .label {
            cursor: text;
            font-size: 14px;
            color: ${colors.gray};
            display: flex;
            font-family: 'AvenirNextforINTUIT-Regular';
          }

          &.ap {
            display: flex;
            justify-content: flex-end;
            font-size: ${fontSize.xxs};
            color: ${colors.gray};
            margin-top: 0;
          }

          .right {
            text-align: right;
            font-family: 'AvenirNextforINTUIT-Regular';
            max-width: 115px;
          }

          .amount-container {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            gap: 4px;
          }

          .outstanding-balance-text {
            font-family: 'AvenirNextforINTUIT-Regular';
            font-size: ${fontSize.xxs};
            color: ${colors.gray02};
            margin-top: 2px;
          }

          .left {
            text-align: left;
            display: flex;
            flex: 1;
            min-width: 0;
            overflow: hidden;
          }

          .invoice-label {
            margin-right: 4px;
            flex-shrink: 0;
          }

          .invoice-number {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            min-width: 0;
          }
        }

        li {
          display: block;
        }
      `}</style>
    </>
  );
};

export default BatchInvoiceSummary;
